// eslint-disable-next-line import/extensions
import IonDialog from './src/main.js';

export default IonDialog;
